export default function Logo(props: React.ComponentProps<'svg'>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="32"
      fill="none"
      viewBox="0 0 22 32"
      {...props}
    >
      <path
        fill="gray.muted"
        d="M9.493 4a1.359 1.359 0 00-1.997-1.203A13.623 13.623 0 000 14.979c0 7.06 5.352 12.866 12.206 13.55v1.088h-.34a2.038 2.038 0 00-2.034 2.043c0 .188.152.34.34.34h6.78a.34.34 0 00.34-.34c0-1.128-.911-2.043-2.035-2.043h-.339v-3.058c0-.41-.357-.725-.765-.703-.195.011-.393.016-.591.016-5.992 0-10.85-4.877-10.85-10.893 0-4.25 2.424-7.931 5.96-9.727.483-.208.821-.69.821-1.252z"
      />
      <path
        fill="success.muted"
        d="M12.206 2.723A2.718 2.718 0 0114.918 0h3.051a.68.68 0 01.678.68v1.703a2.718 2.718 0 01-2.712 2.723h-3.051a.68.68 0 01-.678-.68V2.723z"
      />
      <ellipse cx="13.562" cy="14.979" fill="error.muted" rx="7.798" ry="7.83" />
    </svg>
  )
}
